import { success } from "App/popupMessage";
import locale from "./actionCreators.locale";
import actionTypes from "./actionTypes";
import api from "./api";
export default {
    getRoles: () => ({
        type: actionTypes.GET_ROLES,
        payload: {
            promise: () => api.getRoles()
        }
    }),
    removeRoles: (ids) => ({
        type: actionTypes.REMOVE_ROLES,
        payload: {
            promise: () => api.removeRoles(ids)
        },
        meta: { ids },
        completed: (dispatch) => {
            dispatch(success(ids.length > 1 ? locale.ROLES_REMOVED_SUCCESSFULLY : locale.ROLE_REMOVED_SUCCESSFULLY));
        }
    }),
    saveRole: (data, completed) => ({
        type: actionTypes.SAVE_ROLE,
        payload: {
            promise: () => api.saveRole(data)
        },
        meta: { id: data.Id },
        completed: (dispatch) => {
            dispatch(success(data.Id ? locale.ROLE_EDITED_SUCCESSFULLY : locale.ROLE_CREATED_SUCCESSFULLY));
            completed && completed();
        },
        scope: `${actionTypes.SAVE_ROLE}_${data.Id}`
    }),
    setExpandedPermissions: (expandedPermissions) => ({
        type: actionTypes.SET_EXPANDED_PERMISSIONS,
        expandedPermissions
    })
};
